export const MAX_MESSAGE_LENGTH = 4096;
export const COUNT_UPLOADED_MESSAGES = 25;
